import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from './components/components.module';

@NgModule({
  exports: [ComponentsModule],
  imports: [CommonModule, ComponentsModule],
  declarations: []
})
export class SharedModule {}
